import Cookies from "js-cookie";

export const cookieBanner = () => {
  const $cookieBanner = document.querySelector(".cookie-banner");

  if ($cookieBanner) {
    window.Shopify.loadFeatures(
      [
        {
          name: "consent-tracking-api",
          version: "0.1",
        },
      ],
      (error) => {
        const showBanner = () => {
          $cookieBanner.classList.remove("opacity-0", "pointer-events-none");
        };

        const hideBanner = () => {
          $cookieBanner.classList.add("opacity-0", "pointer-events-none");
        };

        const handleAccept = (event) => {
          window.Shopify.customerPrivacy.setTrackingConsent(true, hideBanner);
        };

        const handleDecline = () => {
          window.Shopify.customerPrivacy.setTrackingConsent(false, hideBanner);
        };

        const $cookieBannerAccept = $cookieBanner.querySelector(
          ".cookie-banner__button.cookie-banner__button--accept"
        );

        $cookieBannerAccept.addEventListener("click", (event) => {
          handleAccept(event);
        });

        const $cookieBannerDecline = $cookieBanner.querySelector(
          ".cookie-banner__button.cookie-banner__button--decline"
        );
        $cookieBannerDecline.addEventListener("click", (event) => {
          handleDecline(event);
        });

        const userCanBeTracked =
          window.Shopify.customerPrivacy.userCanBeTracked();

        const userTrackingConsent =
          window.Shopify.customerPrivacy.getTrackingConsent();

        if (!userCanBeTracked && userTrackingConsent === "no_interaction") {
          showBanner();
        }
      }
    );
  }
};

export default cookieBanner;
